'use client';

interface StatusNotificationBadgeProps {
  count?: number;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'success' | 'warning' | 'error';
  className?: string;
  showZero?: boolean;
  pulse?: boolean;
}

const StatusNotificationBadge = ({
  count = 0,
  size = 'md',
  variant = 'default',
  className = '',
  showZero = false,
  pulse = false,
}: StatusNotificationBadgeProps) => {
  if (!showZero && count === 0) return null;

  const displayCount = count > 99 ? '99+' : count.toString();

  const sizeClasses = {
    sm: 'min-w-[16px] h-4 text-[10px] px-1',
    md: 'min-w-[20px] h-5 text-xs px-1.5',
    lg: 'min-w-[24px] h-6 text-sm px-2',
  };

  const variantClasses = {
    default: 'bg-accent text-white',
    success: 'bg-success text-white',
    warning: 'bg-warning text-white',
    error: 'bg-error text-white',
  };

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-caption font-500 leading-none
        ${sizeClasses[size]}
        ${variantClasses[variant]}
        ${pulse ? 'animate-pulse' : ''}
        ${className}`}
      aria-label={`${count} notifications`}
    >
      {displayCount}
    </span>
  );
};

export default StatusNotificationBadge;